
import { CaseModule } from '../case/case.module';
import { QueryBuilderModule } from '../shared/query-builder/query-builder.module';
import { TaskModule } from '../task/task.module';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { HelpDocumentListComponent } from './help-document-list/help-document-list.component';
import { HelpDocumentEditComponent } from './help-document-edit/help-document-edit.component';
import { MessageModule } from '../message/message.module';
import { ChannelModule } from '../channel/channel.module';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    SharedModule,
    TaskModule,
    QueryBuilderModule,
    CaseModule,
    MessageModule,
    ChannelModule,
    NgbModule
  ],
  exports: [
  ],
  declarations: [
    HelpDocumentListComponent,
    HelpDocumentEditComponent
  ],
  providers: [
  ]

})
export class HelpDocumentModule { }

